<template>
  <div class="defaultDiv"><nopage></nopage></div>
</template>
<script>
import nopage from "../../components/tips/404Page";
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {
    nopage
  },
  async mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.defaultDiv {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
